import { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router'
import { findCotizacionesAll, findCotizaciones } from '../../Fetch/FindCotizaciones'
import Navbar from "../../Components/NavBar/Navbar";
import Loading from "../../Components/Loading/Loading";
import PDFLogo from "../../PDF.svg"
import './css/findcotizacion.css'
import './css/findcotizacion-phone.css'

export default function FindCotizacion() {
  const [r, setr] = useState({ Cotid: '', idStatus: '', show: false, data: [], filters: [] });
  let navigate = useNavigate();
  useEffect(() => {
    document.title = 'Cotizaciones';
    if (localStorage.getItem("ContaKMPCot")) {
      findCotizacionesAll().then(res => {
        if (res.valid) {
          localStorage.setItem("ContaKMPCot", res.token);
          setr(v => ({
            ...v,
            show: true,
            data: res.payload.data,
            filters: res.payload.filters
          }));
        } else {
          localStorage.removeItem("ContaKMPCot")
          navigate("/")
        }

      }).catch(e => {
        console.log(e)
      })
    } else {
      navigate("/");
    }

  }, [navigate])

  const Buscar = (e) => {
    e.preventDefault();
    findCotizaciones(r.Cotid, r.idStatus).then(res => {
      setr({
        ...r,
        data: res.payload.data,
        filters: res.payload.filters
      });
    })
  }

  const Filtrar = (e, tag) => {
    e.preventDefault();
    findCotizaciones(r.Cotid, e.target.value).then(res => {
      setr(v => ({
        ...v,
        show: true,
        idStatus: e.target.value,
        data: res.payload.data,
        filters: res.payload.filters
      }));
    })
  }

  return (
    r.show === false ?
      <Loading />
      :
      <Navbar
        menu={[
          { txt: "Pagos", link: "/Pagos" }
        ]}
      >
        <table className="FindCot">
          <thead>
            <tr>
              <td colSpan={9}>
                <form onSubmit={Buscar}>
                  <input placeholder='Cotización' size="50" onChange={(e) =>
                    setr({
                      ...r,
                      Cotid: e.target.value
                    })} />
                  <select defaultValue={r.idStatus} onChange={(e) => {
                    Filtrar(e, 'status')
                  }}>
                    <option value={''}>Todas</option>
                    {r.filters.map((el, index) =>
                      <option key={index} value={el.idStatus}>{el.Status}</option>
                    )}
                  </select>
                  <button type='submit'>Buscar</button>
                </form>
              </td>
            </tr>
            <tr className='Flags'>
              <td>Cotización</td>
              <td>Fecha de Creación</td>
              <td>Fecha de Vigencia</td>
              <td>Descripción</td>
              <td>Total</td>
              <td>Status</td>
              <td>Pagado</td>
              <td>Restante</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {r.data.map((el, index) =>
              <tr key={index} onClick={(e) => { }}>
                <td width={330}>KMP-{el.idCotizacion}</td>
                <td width={330}>{el.Fecha_Creacion}</td>
                <td width={330}>{el.Fecha_Vigencia}</td>
                <td width={330}>{el.Descripcion}</td>
                <td width={330}>$ {new Intl.NumberFormat('en-US').format(el.Total)}</td>
                <td width={330}>{el.Status}</td>
                {
                  el.Monto_Pagado == null ?
                    <>
                      <td width={330}>a</td>
                      <td width={330}>a</td>
                    </>
                    :
                    <>
                      <td width={330}>
                        {
                          el.idStatus !== 4 & el.idStatus !== 1 ?
                            el.idStatus === 6 | el.idStatus === 3 ?
                              '$ ' + new Intl.NumberFormat('en-US').format(el.Monto_Pagado)
                              :
                              <>
                              <Link to={`/Desglose?id=${el.idCotizacion}&hash=${el.idCothash}`} target="_blank" rel="noopener noreferrer">
                                $ {new Intl.NumberFormat('en-US').format(el.Monto_Pagado)}
                              </Link>
                              
                              </>
                            :
                            ''
                        }
                      </td>
                      <td width={330}>
                        {el.idStatus !== 4 & el.idStatus !== 1 ?
                          '$ ' + new Intl.NumberFormat('en-US').format(el.Restante)
                          :
                          ''
                        }
                      </td>
                    </>
                }
                <td><Link to={`/Link/${el.hash}/${el.idCotizacion}`} target="_blank"><img className='LogoPDF' src={PDFLogo} alt="Logo PDF" /></Link></td>
              </tr>
            )}
          </tbody>
        </table>
      </Navbar>
  )
}
